module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBold.b627802.eot";